<template>
  <div class="row titles">
    <h2 class="titles-main">
      <slot></slot>
    </h2>
    <p v-if="sub" class="titles-sub">{{ sub }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    sub: String,
  },
};
</script>

<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=EB+Garamond|Cardo:400italic);

.titles {
  text-align: center;
  margin-bottom: 20px;

  .titles-main {
    font-family: Georgia, "Times New Roman", Times, serif;
    font-size: 2.5em;
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: normal;
  }

  .titles-sub {
    font-family: "Lucida Grande", Tahoma;
    font-size: 1em;
    font-weight: lighter;
    font-variant: normal;
    text-transform: uppercase;
    color: #666666;
    letter-spacing: 0.3em;
    margin-top: 10px;
  }
}

.titles::after {
  font-family: "EB Garamond", serif;
  content: "§";
  display: block;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  color: #76665b;
  margin: 0 0.6em;
  font-size: 1.25em;
}

@media screen and (max-width: 600px) {
 .titles {

  .titles-main {
    font-size: 2em;
  }

  .titles-sub {
      font-size: 1em;
    }
  }
}
</style>
